import './PrivacyPolicy.scss';

export default function PrivacyPolicy({ }) {

    return (
        <div className="PrivacyPolicy">
            <h1>Privacy Policy – GenesisStake</h1>
            <p><strong>Last Updated:</strong> 09 April, 2025</p>

            <h2>Summary for Visitors</h2>
            <p>
                Our privacy policy explains what information we collect, how we use it, and your choices regarding your data. This summary highlights the key points in clear language, but the full policy is legally binding.
            </p>
            <p>
                <strong>Who this applies to:</strong><br />
                This privacy policy applies to visitors of GenesisStake.com and its subdomains.
            </p>
            <p>
                <strong>What we collect:</strong><br />
                When you visit our website, we may collect:
                <ul>
                    <li>Pages you view and links you click</li>
                    <li>The site you came from and where you go next</li>
                    <li>Technical information about your device, browser, and location</li>
                    <li>If you use our “click to call” feature, we may collect your phone number for up to 3 months</li>
                </ul>
            </p>
            <p>
                <strong>How we use your information:</strong>
                <ul>
                    <li>Operate and improve our website and services</li>
                    <li>Analyze usage and performance</li>
                    <li>Manage partnerships with s, vendors, and affiliates</li>
                    <li>Resolve payment or tracking issues with partners</li>
                </ul>
            </p>
            <p>
                <strong>Sharing your data:</strong><br />
                We do not sell your personal information. We only share it when required by law, to provide our services, or to process payments and tracking with trusted partners.
            </p>
            <p>
                For complete details, please review the full Privacy Policy below or email <a href="mailto:privacy@genesisstake.com">privacy@genesisstake.com</a> with questions.
            </p>

            <h2>Full Privacy Policy</h2>

            <h3>1. Introduction</h3>
            <p>
                This Privacy Policy describes how GenesisStake (“we,” “our,” or “us”) collects, uses, and protects your information when you use our website (GenesisStake.com) and related services (“Services”).
            </p>
            <p>
                By accessing our site, you consent to this policy. If you do not agree, please discontinue use of our website.
            </p>

            <h3>2. Information We Collect</h3>
            <p>
                <strong>a) Information You Provide</strong>
                <ul>
                    <li><strong>Contact Forms & Inquiries</strong> – Your name, email, and message when you contact us.</li>
                    <li><strong>Newsletter Signups & Promotions</strong> – Your name, email, and consent for marketing.</li>
                    <li><strong> Offer Forms</strong> – Information you submit to request details from a  partner.</li>
                </ul>
            </p>
            <p>
                <strong>b) Information Automatically Collected</strong>
                <ul>
                    <li>Device type, browser version, operating system, IP address, and language settings</li>
                    <li>Pages viewed, links clicked, and referral URLs</li>
                    <li>Cookies, pixels, and similar technologies for analytics, personalization, and fraud prevention</li>
                </ul>
            </p>
            <p>
                <strong>c) Information from Third Parties</strong><br />
                We may receive tracking and performance data from advertising networks, affiliate platforms, and analytics providers to measure visits, clicks, and conversions.
            </p>

            <h3>3. How We Use Your Information</h3>
            <p>
                We use collected information to:
                <ul>
                    <li>Operate, maintain, and improve our site</li>
                    <li>Track clicks, conversions, and commissions with partners</li>
                    <li>Show relevant offers and content</li>
                    <li>Monitor for fraudulent activity and security threats</li>
                    <li>Comply with legal requirements</li>
                </ul>
            </p>

            <h3>4. Sharing Your Information</h3>
            <p>
                We share data only in these cases:
                <ul>
                    <li><strong> & Affiliate Partners</strong> – If you click an offer or fill out a form for a , we may share the relevant data so the partner can respond.</li>
                    <li><strong>Service Providers</strong> – Such as hosting, analytics, email services, and fraud detection tools.</li>
                    <li><strong>Legal & Compliance</strong> – When required to comply with laws or protect our rights.</li>
                </ul>
                We do not sell personal information.
            </p>

            <h3>5. Cookies & Tracking</h3>
            <p>
                We use cookies, pixels, and similar technologies for analytics, personalization, and tracking affiliate referrals. You can disable cookies in your browser, but some features may not work properly.
            </p>
            <p>
                For details, see our Cookie Policy.
            </p>

            <h3>6. Data Retention</h3>
            <p>
                We keep your data only as long as needed to fulfill the purposes described in this policy or as required by law.
            </p>

            <h3>7. Security</h3>
            <p>
                We use SSL encryption, secure hosting, and restricted access to protect your data. No method is 100% secure, so we cannot guarantee absolute protection.
            </p>

            <h3>8. Children’s Privacy</h3>
            <p>
                GenesisStake is not intended for individuals under the age of 18. We do not knowingly collect data from minors. If we learn we have, we will delete it promptly.
            </p>

            <h3>9. Your Rights</h3>
            <p>
                Depending on your location, you may have the right to:
                <ul>
                    <li>Access, correct, or delete your personal information</li>
                    <li>Withdraw consent for marketing</li>
                    <li>Request details on data sharing with third parties</li>
                </ul>
                To exercise these rights, email <a href="mailto:privacy@genesisstake.com">privacy@genesisstake.com</a>.
            </p>

            <h3>10. International Users</h3>
            <p>
                If you access our site from outside the U.S., your data may be transferred to and stored in the U.S. or other jurisdictions with different privacy laws.
            </p>

            <h3>11. Changes to This Policy</h3>
            <p>
                We may update this policy at any time. We will post changes here and update the “Last Updated” date. Significant changes may be announced via a notice on our site.
            </p>

            <h3>12. Contact Us</h3>
            <p>
                For questions about this policy or your data, email <a href="mailto:privacy@genesisstake.com">privacy@genesisstake.com</a>.
            </p>
        </div >
    )
}

